/**
 * Returns the appropriate CSS class for a given user role
 * @param {string} role - The user role
 * @returns {string} - CSS class for the role
 */


/**
 * Returns the appropriate color for a given user role
 * @param {string} role - The user role
 * @param {number} opacity - Optional opacity level (0-1)
 * @returns {string} - CSS color for the role
 */
export const getRoleColor = (role, opacity = 1) => {
  if (!role) return opacity < 1 ? 'rgba(209, 213, 219, ' + opacity + ')' : '#D1D5DB';
  
  const roleColors = {
    'administrateur': opacity < 1 ? 'rgba(220, 38, 38, ' + opacity + ')' : '#000', // red-600
    'artistesprod': opacity < 1 ? 'rgba(124, 58, 237, ' + opacity + ')' : '#000', // violet-600
    'billeterie': opacity < 1 ? 'rgba(255, 192, 203, ' + opacity + ')' : '#000', // rose
   'permanence': opacity < 1 ? 'rgba(144, 238, 144, ' + opacity + ')' : '#000', // vert clair
    'regie':      opacity < 1 ? 'rgba(165, 42, 42, ' + opacity + ')' : '#000',   // marron
    'communication': opacity < 1 ? 'rgba(236, 72, 153, ' + opacity + ')' : '#000', // pink-600
    'artistescoprod':   opacity < 1 ? 'rgba(255, 206, 86,' + opacity + ')' : '#000', // 
    'professeur': opacity < 1 ? 'rgba(75, 0, 130, ' + opacity + ')' : '#000', // indigo
    'consultation': opacity < 1 ? 'rgba(59, 130, 246, ' + opacity + ')' : '#000', // blue-500
  };
  
  return roleColors[role.toLowerCase()] || (opacity < 1 ? 'rgba(209, 213, 219, ' + opacity + ')' : '#D1D5DB');
};